/**
 * Laddar inloggningsklienten först när den behövs.
 *
 * Klienten är ett av de tyngsta biblioteken i bygget. Publika besökare är
 * nästan aldrig inloggade, så vi hämtar den efter första renderingen i stället
 * för att lägga den i startsidans kod.
 */
export async function loadSupabase() {
  const mod = await import("@/integrations/supabase/client");
  return mod.supabase;
}

/** Undvik att hämta auth-klienten för anonyma besökare. */
export function hasStoredAuthSession(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return Object.keys(window.localStorage).some(
      (key) => key.startsWith("sb-") && key.endsWith("-auth-token") && Boolean(window.localStorage.getItem(key)),
    );
  } catch {
    return false;
  }
}

/** Kör återanropet när webbläsaren är ledig (eller strax efter). */
export function whenIdle(run: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  const ric = (window as unknown as {
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    cancelIdleCallback?: (id: number) => void;
  }).requestIdleCallback;
  if (ric) {
    const id = ric(run, { timeout: 2000 });
    return () => (window as unknown as { cancelIdleCallback?: (id: number) => void }).cancelIdleCallback?.(id);
  }
  const timer = window.setTimeout(run, 300);
  return () => window.clearTimeout(timer);
}
